import React from 'react';

import TextBox from '@components/TextBox/TextBox';
import ImportImages from '@src/importImages';
const BackgroundImage = ImportImages('/suitekey/suitekey.jpg');

const Membership = props => {
  let styles = {};
  let pageContent = '';

  if (window.innerWidth < 992) {
    styles.minHeight = props.screenHeight + 'px';
    styles.background = `url(${BackgroundImage})`;
    styles.backgroundSize = 'auto 100%';
    styles.backgroundPosition = 'center center';
    const propsMobile = { ...props };
    propsMobile.style = { marginTop: '6rem', marginBottom: '4rem' };

    pageContent = (
      <div className={'position-relative align-items-center container-fluid'}>
        <TextBox {...propsMobile} isHeader={true}/>
      </div>
    );
  } else {
    styles.height = props.screenHeight + 'px';
    pageContent = (
      <div
        className={
          'ml-5 pl-5 abs-container d-flex align-items-center container-fluid'
        }
      >
        <TextBox {...props} isHeader={true}/>
      </div>
    );
  }
  return (
    <div id={props.id} className={props.className} style={styles}>
      <img
        src={BackgroundImage}
        alt={'JetSuite'}
        className={'img-fluid d-none d-lg-block img-mobile-background'}
      />
      {pageContent}
    </div>
  );
};

export default Membership;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/Membership/Membership.js